<section>
	<button [loader]="false" circle (click)="onClose.emit()" [selected]="true">
		<icon type="tv" />
	</button>
</section>

@if (!screenAuthGroups)
{
	<skeletons [defaultSkeletons]="1" />
}
@else
{
	@for (group of screenAuthGroups; track group)
	{
		<div class="auth-group">
			<h2>{{ group.name }}</h2>
			@if (group.hasAccessToken)
			{
				<button [active]="false">{{ 'screen-authenticator.has-token' | translate }}</button>
			}
			@else
			{
				<button confirm (click)="generateAccessToken(group)">{{ 'screen-authenticator.generate-token' | translate }}</button>
			}
		</div>
	}
}
